import { Component, DoCheck, EventEmitter, Input, Output } from "@angular/core";
import { Tag, TagGroup } from "../../common/organisation";
import { Linqset, NODE_SUPERTYPE } from "../../common/linqset-model";
import { TagsService } from "../../organisation/tags/tags-service";

// the legend for the tag group shown on the canvas: its tags, how many actions use each, and edit/close
@Component({
    selector: 'app-tags-list',
    templateUrl: './tags-list.html',
    styleUrls: ['./tags-list.css'],
    standalone: false
})
export class TagsListComponent implements DoCheck {
    @Input() tagGroup:TagGroup
    @Input() hasWriteAccess:boolean
    @Input() linqset:Linqset

    // undefined closes the tag group
    @Output() tagEvent = new EventEmitter<Tag>();
    // the tag group was edited, so the labels on the canvas need redrawing
    @Output() changed = new EventEmitter<void>();

    counts:{[tagKey:string]:number} = {}
    untagged = 0

    constructor(private tagsService:TagsService) {
    }

    // tags are changed on nodes elsewhere (the properties panel), so recount on each check; models are small
    ngDoCheck() {
        this.countTags()
    }

    // actions in the model using each tag
    private countTags() {
        this.counts = {}
        this.untagged = 0
        if (!this.tagGroup || !this.linqset) return
        this.linqset.nodes.filter(n => n.superType === NODE_SUPERTYPE.ACTION && !n.excluded).forEach(n => {
            const tagKey = n.properties?.tagKeys?.[this.tagGroup._key]
            if (tagKey) this.counts[tagKey] = (this.counts[tagKey] || 0) + 1
            else this.untagged++
        })
    }

    getColourStyleForTag(tag:Tag) {
        return this.tagsService.getColourStyleForTagIndex(tag.tagIndex)
    }

    async editTagGroup() {
        const result = await this.tagsService.openTagGroupDialog(this.tagGroup)
        if (result === 'deleted') this.closeTagGroup()
        else if (result === 'saved') this.changed.emit()
    }

    closeTagGroup() {
        this.tagGroup = undefined
        this.tagEvent.emit(undefined)
    }
}
